import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

/**
 * Obtain operator settings
 *
 * @param {Object} data
 */
const set = (data = {}) => axios({
  method: 'put',
  url: config.endpoints.operators.settings,
  data,
  headers: getHeaders(true)
})

const get = (data = {}) => axios({
  method: 'post',
  url: config.endpoints.operators.settings,
  data,
  headers: getHeaders(true)
})

export default {
  set,
  get
}